<div class="new-pocket-wrapper">
  <div *ngIf="modalErrors.newPocketName" class="nameError">
    {{ modalErrors.newPocketName }}*
  </div>
  <input
    #newPocketNameInput
    (ngModelChange)="modalErrors.newPocketName = null"
    [(ngModel)]="newPocketName"
    [ngClass]="{ error: modalErrors.newPocketName }"
    appNoLeadingSpace
    class="new-pocket-input"
    placeholder="Enter Pocket Name"
    type="text"
  />
  <app-color-picker
    [hexColor]="newPocketColor?.includes('#')
     ? newPocketColor : '#' + newPocketColor"
    (colorSelected)="selectNewPocketColor($event)"
    (closePopup)="closeColorPickerDialog()"
  ></app-color-picker>
</div>

<p-dialog
  [(visible)]="isColorPickerOpen"
  (close)="closeColorPickerDialog()"
  styleClass="dialog-full-height"
  appendTo="body"
  [modal]="true"
  [resizable]="false"
>
  <app-color-picker [hexColor]="'#' + newPocketColor" (colorSelected)="createNewColor($event)" (closePopup)="closeColorPickerDialog()"></app-color-picker>
</p-dialog>
